var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['coin', _vm.type, {'hoverable': _vm.hoverable, 'smallCoin': _vm.size == 'small', 'mediumCoin': _vm.size == 'medium'}],on:{"click":function($event){return _vm.$emit('coin-clicked')}}},[_c('p',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }